var _defs, _use, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneReceiverAppTile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0_4_Icons_MIB3 / 0_4_3_IconMaster / home / phone_receiver_app_tile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "-21.5725806%",
    x2: "81.672894%",
    y2: "145.884577%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32E563",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#198232",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.5639559,53.3579264 L54.8514875,58.0703893 C53.4305441,59.4913311 51.2019984,59.7903618 49.4994855,58.718653 C37.3025085,51.0377096 26.9586513,40.6960472 19.2776988,28.4969017 C18.2059888,26.7965735 18.5050199,24.5680304 19.9259634,23.1449059 L24.6384318,18.432443 C25.4285724,17.6423033 25.4940536,16.3828818 24.7912214,15.5163474 L12.8932755,0.81800321 C12.0529326,-0.223147692 10.453007,-0.288628881 9.57992346,0.726329546 C9.01896729,1.37895873 8.47329008,2.04904956 7.94725725,2.73223663 C4.84126257,6.77024327 2.36607074,11.3124551 0.661375138,16.2191788 C-0.373228853,19.2007556 -0.159323387,22.4769978 1.06081086,25.3887279 C10.7869615,48.6214537 29.3792754,67.2137459 52.6120283,76.9398852 C55.5237619,78.1578353 58.8000078,78.3739232 61.7815881,77.3393204 C66.6883176,75.6368095 71.2327174,73.1594379 75.268546,70.0534468 C75.9517339,69.5274146 76.6218255,68.981738 77.2744555,68.4207825 C78.2894151,67.5477 78.2217511,65.949959 77.1827817,65.1052517 L62.4822377,53.2051369 C61.6135195,52.5023055 60.3540965,52.5699694 59.5639559,53.3579264 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.14036023%",
    y1: "-62.7377565%",
    x2: "114.373445%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0AFF4B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25D24A",
    stopOpacity: 0.670017483,
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "0_4_Icons_MIB3-/-0_4_3_IconMaster-/-home-/-phone_receiver_app_tile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Phone",
    transform: "translate(6.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Phone---Fill"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.401633523,
    fill: "#13D246",
    style: {
      mixBlendMode: "soft-light"
    },
    xlinkHref: "#path-2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2117193,1.00045947 C11.548727,1.00978378 11.8844337,1.16026385 12.1160122,1.44717864 L12.1160122,1.44717864 L24.0145695,16.1462774 C24.2047815,16.3807932 24.2908475,16.6685128 24.2760473,16.9509846 C24.2612326,17.2337345 24.1453507,17.5113107 23.9313254,17.7253358 L23.9313254,17.7253358 L19.2183145,22.4383416 C18.3419082,23.3160931 17.8139545,24.4438221 17.6723274,25.6130785 C17.5311285,26.7788002 17.7730203,27.985054 18.4314663,29.0297154 C26.1920603,41.3553504 36.643158,51.8042567 48.966759,59.5649405 C50.0129028,60.2234739 51.2195416,60.4651843 52.3849521,60.3240234 C53.5545764,60.1823521 54.6819334,59.654156 55.5585939,58.7774965 L55.5585939,58.7774965 L60.2700836,54.0660109 C60.4847101,53.8519775 60.7631375,53.7359231 61.0468188,53.7210707 C61.3297028,53.7062601 61.6179431,53.7921785 61.8530498,53.9823902 L61.8530498,53.9823902 L76.5519441,65.8811665 C76.8385565,66.1141894 76.9901728,66.4517521 76.9995403,66.7905453 C77.0083914,67.1106576 76.8877932,67.4343163 76.6226208,67.6624214 C75.9835757,68.2117003 75.3274357,68.7460223 74.6586493,69.2609659 C70.7072232,72.3020004 66.2579103,74.7276645 61.4537654,76.3945812 C58.7030687,77.3490678 55.6820228,77.1400755 52.9981934,76.0174555 C30.0071205,66.392493 11.608214,47.9936082 1.98310844,25.0022475 C0.858428804,22.3183103 0.651702578,19.2974763 1.6059908,16.5473575 C3.27511141,11.7430313 5.69872647,7.29565769 8.73959849,3.34231478 C9.25468167,2.67334862 9.78900429,2.01720939 10.3380277,1.37846297 C10.5667081,1.11262228 10.8911401,0.991589699 11.2117193,1.00045947 Z",
    id: "Phone---Border",
    stroke: "url(#linearGradient-3)",
    strokeWidth: 2,
    opacity: 0.518531436
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneReceiverAppTile);
export default __webpack_public_path__ + "static/media/phone_receiver_app_tile.3cd074403cc215c5d48144abc116680c.svg";
export { ForwardRef as ReactComponent };